import { get } from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGetNewMessageCountResponsePayload,
	TMessagesResponsePayload,
	TOrganizationsResponsePayload,
	TOrganizationsRow,
	TUserInfoResponsePayload,
	TUserStore,
	TUsersListResponsePayload,
	TSaveSessionDataRequestPayload,
	TSaveSessionDataResponsePayload,
} from './types';
// ==========================================:
export const initialState: TUserStore = {
	organizations: null,
	organizationsLoader: false,
	userInfo: null,
	userInfoLoader: false,
	xMerchantId: null,
	setOrganization: null,
	newMessageCount: 0,
	newMessageCountLoader: false,
	messages: null,
	messagesLoader: false,
	usersList: null,
	usersListLoader: false,
	saveSessionId: null,
	saveSessionIdLoader: false,
};

// ==========================================:
const user = createSlice({
	name: '@@user',
	initialState,
	reducers: {
		getOrganizationsRequest: (state: TUserStore) => {
			const organizationsRequestState = state;
			organizationsRequestState.organizationsLoader = true;
		},
		getOrganizationsSuccess: (
			state: TUserStore,
			action: PayloadAction<TOrganizationsResponsePayload>,
		) => {
			const { payload } = action;
			const organizationsSuccessState = state;
			organizationsSuccessState.organizations = payload;
			organizationsSuccessState.organizationsLoader = false;
		},
		setOrganization: (state: TUserStore, action: PayloadAction<TOrganizationsRow>) => {
			const { payload } = action;
			const setOrganizationState = state;
			setOrganizationState.setOrganization = payload;
		},

		getUserInfoRequest: (state: TUserStore) => {
			const userInfoRequestState = state;
			userInfoRequestState.userInfoLoader = true;
		},
		getUserInfoSuccess: (state: TUserStore, action: PayloadAction<TUserInfoResponsePayload>) => {
			const { payload } = action;
			const userInfoSuccessState = state;
			userInfoSuccessState.userInfo = payload;
			userInfoSuccessState.userInfoLoader = false;
		},
		setXMerchantId: (state: TUserStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const setXMerchantIdState = state;
			setXMerchantIdState.xMerchantId = payload;
		},
		getNewMessageCountRequest: (state: TUserStore) => {
			const newMessageCountRequestState = state;
			newMessageCountRequestState.newMessageCountLoader = true;
		},
		getNewMessageCountSuccess: (
			state: TUserStore,
			action: PayloadAction<TGetNewMessageCountResponsePayload>,
		) => {
			const { payload } = action;
			const newMessageCountSuccessState = state;
			newMessageCountSuccessState.newMessageCount = payload;
			newMessageCountSuccessState.newMessageCountLoader = false;
		},
		getMessagesRequest: (state: TUserStore) => {
			const getMessagesState = state;
			getMessagesState.messagesLoader = true;
		},
		getMessagesSuccess: (state: TUserStore, action: PayloadAction<TMessagesResponsePayload>) => {
			const { payload } = action;
			const getMessagesSuccessState = state;
			getMessagesSuccessState.messages = payload;
			getMessagesSuccessState.messagesLoader = false;
		},
		getUsersListRequest: (state: TUserStore) => {
			const getUsersListRequestState = state;
			getUsersListRequestState.usersListLoader = true;
		},
		getUsersListSuccess: (state: TUserStore, action: PayloadAction<TUsersListResponsePayload>) => {
			const { payload } = action;
			const getUsersListSuccessState = state;
			getUsersListSuccessState.usersList = payload;
			getUsersListSuccessState.usersListLoader = false;
		},
		getSaveSessionDataRequest: (
			state: TUserStore,
			action: PayloadAction<TSaveSessionDataRequestPayload>,
		) => {},
		getSaveSessionDataSuccess: (
			state: TUserStore,
			action: PayloadAction<TSaveSessionDataResponsePayload>,
		) => {
			const { payload } = action;
			const getSaveSessionDataSuccessState = state;
			getSaveSessionDataSuccessState.saveSessionId = payload;
			getSaveSessionDataSuccessState.saveSessionIdLoader = false;
		},
		assetsInitState: () => initialState,
	},
});

export default user.reducer;
export const {
	getOrganizationsRequest,
	getOrganizationsSuccess,
	setOrganization,
	getUserInfoRequest,
	getUserInfoSuccess,
	setXMerchantId,
	getNewMessageCountRequest,
	getNewMessageCountSuccess,
	getMessagesRequest,
	getMessagesSuccess,
	getUsersListRequest,
	getUsersListSuccess,
	getSaveSessionDataRequest,
	getSaveSessionDataSuccess,
	assetsInitState,
} = user.actions;
